import type { AgGridReact } from "ag-grid-react";
import type { Instrument } from "../const";
import type { InstrumentCompositionEditorProps } from "../instrumentEditor.types";
import { MarketDateField } from "../quantity/market-date/MarketDateField";
import { AddInstrumentsMenu } from "./AddInstrumentsMenu";
import { DecimalsStepper } from "./DecimalsStepper";
import { GroupByClassificationSelect } from "./GroupByClassificationSelect";
import { resolveQuickActions } from "./quickActions";

/**
 * The header row over the composition grid, and the only place that decides what sits in it. Which
 * controls an entity gets is declared in `quickActions.ts`; each control is its own component and
 * owns whatever state it drives.
 */
export function CompositionQuickActions(
	props: InstrumentCompositionEditorProps & { agGrid: AgGridReact<Instrument> | null },
): React.JSX.Element {
	const quickActions = resolveQuickActions(props);

	return (
		<div className="flex gap-2 mb-4 items-end">
			{quickActions.marketDate && (
				<MarketDateField control={quickActions.marketDate} compositionMode={props.compositionMode} />
			)}
			{quickActions.decimals && <DecimalsStepper />}
			{quickActions.groupByClassification && <GroupByClassificationSelect agGrid={props.agGrid} />}
			<AddInstrumentsMenu {...props} actionKeys={quickActions.addMenu} />
		</div>
	);
}
